export enum NotificationTypeId {
  OvenPanelTurnedOn = 1,
  OvenPanelTurnedOff = 2,
  OvenPanelStartedRecipe = 3,
  OvenPanelFinishedRecipe = 4,
  OvenPanelStartedWashing = 5,
  OvenPanelFinishedWashing = 6,
  OvenPanelStartedSync = 7,
  OvenPanelFinishedSync = 8,
  OvenPanelFailedSync = 9,
  OvenPanelStartedUpdate = 10,
  OvenPanelFinishedUpdate = 11,
  OvenPanelFailedUpdate = 12,
  OvenPanelStartedOverheat = 13,
  OvenPanelStoppedOverheat = 14,
  OvenPanelStartedTurbineOverheat = 15,
  OvenPanelStoppedTurbineOverheat = 16,
  OvenPanelStartedPowerFailure = 17,
  OvenPanelStoppedPowerFailure = 18,
  OvenPanelSettingsChanged = 19,
  PeriodicMaintenanceRequired = 20,
  StartedPCBOverheating = 21,
  StoppedPCBOverheating = 22,
  StartedThermocoupleError = 23,
  StoppedThermocoupleError = 24,
  StartedThermocoupleTemperatureMeasurementError = 25,
  StoppedThermocoupleTemperatureMeasurementError = 26,
  StartedThermocoupleConnectionError = 27,
  StoppedThermocoupleConnectionError = 28,
  StartedThermocoupleTemperatureMeasurementStuckError = 29,
  StoppedThermocoupleTemperatureMeasurementStuckError = 30,
  StartedForcedCoolingError = 31,
  StoppedForcedCoolingError = 32,
}

type Notification = {
  id: string;
  body?: string | null;
  notificationTypeId: number;
  ovenPanelId?: string | null;
  ovenChamberId?: string | null;
  ovenId?: string | null;
  ovenGroupId?: string | null;
  bakeryId?: string | null;
  companyId?: string | null;
  userId?: string | null;
  isSeen?: boolean | null;
  isFlagged?: boolean | null;
  notificationTypeDescription: string;
  ovenPanelOrder?: number | null;
  ovenChamberOrder?: number | null;
  ovenDescription?: string | null;
  ovenOrder?: number | null;
  ovenGroupDescription?: string | null;
  bakeryName?: string | null;
  userName?: string | null;
  createdAt: string;
};

export default Notification;
